import { render, staticRenderFns } from "./VideoBankEntityDetails.vue?vue&type=template&id=5f1e5ef8&scoped=true"
import script from "./VideoBankEntityDetails.vue?vue&type=script&lang=js"
export * from "./VideoBankEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./VideoBankEntityDetails.vue?vue&type=style&index=0&id=5f1e5ef8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e5ef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1e5ef8')) {
      api.createRecord('5f1e5ef8', component.options)
    } else {
      api.reload('5f1e5ef8', component.options)
    }
    module.hot.accept("./VideoBankEntityDetails.vue?vue&type=template&id=5f1e5ef8&scoped=true", function () {
      api.rerender('5f1e5ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoBankEntityDetails.vue"
export default component.exports